import styled from "styled-components";
import colors from "../../constants/colors";

export const OtpContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  gap: "1rem",
});

export const OtpInputsWrapper = styled("div")({
  display: "flex",
  gap: "0.75rem",
  justifyContent: "center",
  direction: "ltr", // Keep boxes left-to-right for natural digit order
  flexWrap: "wrap",

  "@media (max-width: 480px)": {
    gap: "0.5rem",
  },
});

export const OtpInputBox = styled("input")<{
  $hasValue?: boolean;
  $error?: boolean;
}>(({ $hasValue, $error }) => ({
  width: "3rem",
  height: "3.5rem",
  fontSize: "1.5rem",
  fontWeight: 600,
  textAlign: "center",
  border: `2px solid ${$error ? colors.ORANGE : $hasValue ? colors.PURPLE : colors.GREY_3}`,
  borderRadius: "12px",
  backgroundColor: colors.WHITE,
  color: colors.BLACK,
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  outline: "none",
  caretColor: colors.PURPLE,

  "&:focus": {
    borderColor: $error ? colors.ORANGE : colors.PURPLE,
    boxShadow: $error
      ? `0px 0px 0px 4px rgba(255, 165, 0, 0.1)`
      : `0px 0px 0px 4px ${colors.PURPLE_LIGHTER}`,
  },

  "&:disabled": {
    backgroundColor: colors.GREY_2,
    cursor: "not-allowed",
    color: colors.GREY_5,
  },

  // Remove number input spinners
  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },

  "&[type=number]": {
    MozAppearance: "textfield",
  },

  "@media (max-width: 480px)": {
    width: "2.5rem",
    height: "3rem",
    fontSize: "1.25rem",
  },
}));

export const ErrorText = styled("div")({
  fontSize: "0.875rem",
  color: colors.ORANGE,
  fontWeight: 500,
  textAlign: "center",
  direction: "rtl",
  unicodeBidi: "embed",
  marginTop: "0.25rem",
});
